(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-page"] && !Shopify.designMode) return;
  try {
    
  class CppSimilarSlider extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.track = this.querySelector('.cpp-similar-slider');
      this.previous = this.querySelector('.cpp-s-prev');
      this.next = this.querySelector('.cpp-s-next');
      this.addEventListener('click', event => {
        const arrow = event.target.closest('.cpp-s-arrow');
        if (!arrow || arrow.disabled) return;
        const step = (this.track.firstElementChild?.getBoundingClientRect().width || 0) + parseFloat(getComputedStyle(this.track).gap || 0);
        this.track.scrollBy({ left: arrow === this.previous ? -step : step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, { signal });
      this.track.addEventListener('scroll', () => this.updateArrows(), { signal, passive: true });
      this.resizeObserver?.disconnect();
      this.resizeObserver = new ResizeObserver(() => this.updateArrows());
      this.resizeObserver.observe(this.track);
      this.updateArrows();
    }
    updateArrows() {
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }
  }
  if (!customElements.get('cpp-similar-slider')) customElements.define('cpp-similar-slider', CppSimilarSlider);
  class CppRoutineSlider extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.track = this.querySelector('.cpp-routine-slider');
      this.previous = this.querySelector('.cpp-routine-nav.prev');
      this.next = this.querySelector('.cpp-routine-nav.next');
      this.addEventListener('click', event => {
        const opener = event.target.closest('[data-routine-open]');
        const direct = event.target.closest('[data-routine-add]');
        if (opener) {
          const dialog = [...this.querySelectorAll('dialog')].find(d => d.id === opener.dataset.routineOpen);
          if (!dialog) return;
          this.opener = opener;
          this.savedOverflow = document.body.style.overflow;
          dialog.showModal();
          document.body.style.overflow = 'hidden';
        } else if (event.target.closest('[data-routine-close]')) {
          event.target.closest('dialog').close();
        } else if (direct && !direct.disabled) {
          this.addProduct(direct, direct.dataset.routineAdd, 1, direct.closest('article'));
        } else if (event.target.closest('.cpp-routine-nav')) {
          const direction = event.target.closest('.prev') ? -1 : 1;
          const step = (this.track.firstElementChild?.getBoundingClientRect().width || 0) + parseFloat(getComputedStyle(this.track).gap);
          this.track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }
      }, { signal });
      this.addEventListener('change', event => {
        const select = event.target.closest('select[name="id"]');
        if (!select) return;
        const selected = select.selectedOptions[0];
        const dialog = select.closest('dialog');
        select.form.querySelector('[type="submit"]').disabled = !selected?.value || selected.disabled;
        if (selected?.dataset.price) dialog.querySelector('[data-routine-price]').textContent = selected.dataset.price;
        const image = dialog.querySelector('.cpp-routine-preview-image');
        if (image && selected?.dataset.image) {
          image.removeAttribute('srcset');
          image.src = selected.dataset.image;
        }
      }, { signal });
      // Handle only this block's forms; leave the main PDP gift workflow alone.
      this.addEventListener('submit', event => {
        const form = event.target.closest('.cpp-routine-form');
        if (!form) return;
        event.preventDefault();
        event.stopPropagation();
        const button = form.querySelector('[type="submit"]');
        if (!button.disabled && form.reportValidity()) {
          this.addProduct(button, form.elements.id.value, Number(form.elements.quantity.value), form);
        }
      }, { signal });
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('close', () => this.restorePage(), { signal });
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const r = dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
        }, { signal });
      });
      this.track.addEventListener('scroll', () => this.updateArrows(), { signal, passive: true });
      this.resizeObserver?.disconnect();
      this.resizeObserver = new ResizeObserver(() => this.updateArrows());
      this.resizeObserver.observe(this.track);
      this.updateArrows();
    }
    updateArrows() {
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
    }
    async addProduct(button, id, quantity, container) {
      if (this.adding || !id || !Number.isInteger(quantity) || quantity < 1) return;
      this.adding = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      const error = container.querySelector('.cpp-routine-error');
      error.hidden = true;
      let added = false;
      try {
        const response = await fetch(this.dataset.cartAdd, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity }] })
        });
        if (!response.ok) throw new Error('Cart rejected item');
        await response.json();
        added = true;
      } catch {
        error.textContent = this.dataset.error;
        error.hidden = false;
      } finally {
        this.adding = false;
        button.disabled = false;
        button.setAttribute('aria-busy', 'false');
      }
      if (!added) return;
      this.querySelector('dialog[open]')?.close();
      document.dispatchEvent(new CustomEvent('cart:updated'));
      // A drawer refresh failure must not retry a successful cart addition.
      try { await window.refreshOxifyCartDrawer?.(); } catch {}
      if (typeof window.openOxifyCartDrawer === 'function') window.openOxifyCartDrawer();
      else window.location.assign(this.dataset.cartUrl);
    }
    restorePage() {
      if (this.savedOverflow !== undefined) {
        document.body.style.overflow = this.savedOverflow;
        this.savedOverflow = undefined;
      }
      if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.querySelectorAll('dialog[open]').forEach(d => d.close());
      this.restorePage();
    }
  }
  if (!customElements.get('cpp-routine-slider')) customElements.define('cpp-routine-slider', CppRoutineSlider);
  class CppVideoSlider extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.track = this.querySelector('.cpp-video-slider-wrapper');
      this.cards = [...this.querySelectorAll('.cpp-video-thumbnail')];
      this.dialog = this.querySelector('dialog');
      this.player = this.querySelector('.cpp-modal-video-player');
      this.previous = this.querySelector('.cpp-v-prev');
      this.next = this.querySelector('.cpp-v-next');
      this.index = 0;
      this.addEventListener('click', event => {
        const card = event.target.closest('.cpp-video-thumbnail');
        if (card) {
          this.opener = card;
          this.savedOverflow = document.body.style.overflow;
          this.dialog.showModal();
          document.body.style.overflow = 'hidden';
          this.showVideo(this.cards.indexOf(card));
        } else if (event.target.closest('.cpp-modal-close-btn') || event.target === this.dialog) {
          this.dialog.close();
        } else if (event.target.closest('.cpp-modal-prev')) this.showVideo(this.index - 1);
        else if (event.target.closest('.cpp-modal-next')) this.showVideo(this.index + 1);
        else if (event.target.closest('.cpp-v-prev')) this.moveTrack(-1);
        else if (event.target.closest('.cpp-v-next')) this.moveTrack(1);
      }, { signal });
      this.dialog.addEventListener('close', () => this.cleanup(), { signal });
      this.dialog.addEventListener('keydown', event => {
        // Preserve the video's native seek/volume keyboard controls.
        if (event.target === this.player) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.showVideo(this.index + (event.key === 'ArrowLeft' ? -1 : 1));
        }
      }, { signal });
      this.dialog.addEventListener('touchstart', event => {
        this.touch = null;
        if (event.touches.length !== 1 || event.target.closest('button')) return;
        const point = event.touches[0];
        const rect = this.player.getBoundingClientRect();
        if (event.target === this.player && point.clientY > rect.bottom - 56) return;
        this.touch = { x: point.clientX, y: point.clientY };
      }, { signal, passive: true });
      this.dialog.addEventListener('touchend', event => {
        if (!this.touch || !event.changedTouches.length) return;
        const point = event.changedTouches[0];
        const dx = point.clientX - this.touch.x;
        const dy = point.clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          this.showVideo(this.index + (dx < 0 ? 1 : -1));
        }
      }, { signal, passive: true });
      this.dialog.addEventListener('touchcancel', () => { this.touch = null; }, { signal, passive: true });
      this.track.addEventListener('scroll', () => this.updateArrows(), { signal, passive: true });
      this.resizeObserver?.disconnect();
      this.resizeObserver = new ResizeObserver(() => this.updateArrows());
      this.resizeObserver.observe(this.track);
      this.updateArrows();
    }
    updateArrows() {
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
    }
    moveTrack(direction) {
      const step = (this.track.firstElementChild?.getBoundingClientRect().width || 0) + parseFloat(getComputedStyle(this.track).columnGap || 0);
      this.track.scrollBy({ left: step * direction, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    showVideo(index) {
      if (index < 0 || index >= this.cards.length) return;
      this.index = index;
      this.player.pause();
      this.player.src = this.cards[index].dataset.videoSrc;
      this.player.poster = this.cards[index].querySelector('img')?.currentSrc || '';
      this.player.load();
      this.player.play().catch(() => {});
      this.querySelector('.cpp-modal-counter').textContent = (index + 1) + ' / ' + this.cards.length;
      this.querySelector('.cpp-modal-prev').disabled = index === 0;
      this.querySelector('.cpp-modal-next').disabled = index === this.cards.length - 1;
    }
    cleanup() {
      this.player?.pause();
      this.player?.removeAttribute('src');
      this.player?.load();
      if (this.savedOverflow !== undefined) {
        document.body.style.overflow = this.savedOverflow;
        this.savedOverflow = undefined;
      }
      if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.dialog?.close();
      this.cleanup();
    }
  }
  if (!customElements.get('cpp-video-slider')) customElements.define('cpp-video-slider', CppVideoSlider);
  class CppInfoAccordion extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('click', event => {
        const trigger = event.target.closest('.cpp-accordion-trigger');
        if (!trigger || trigger.closest('cpp-info-accordion') !== this) return;
        const selected = trigger.closest('.cpp-accordion-item');
        const shouldOpen = trigger.getAttribute('aria-expanded') !== 'true';
        this.querySelectorAll('.cpp-accordion-item').forEach(item => {
          const open = item === selected && shouldOpen;
          item.classList.toggle('active', open);
          item.querySelector('.cpp-accordion-trigger').setAttribute('aria-expanded', String(open));
          const panel = item.querySelector('.cpp-accordion-content');
          panel.setAttribute('aria-hidden', String(!open));
          panel.inert = !open;
        });
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  if (!customElements.get('cpp-info-accordion')) customElements.define('cpp-info-accordion', CppInfoAccordion);
  class CppProductPrice extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.frame = requestAnimationFrame(() => {
        this.prices = JSON.parse(this.querySelector('[data-variant-prices]').textContent);
        const section = this.closest('.custom-product-page');
        const selected = [...section.querySelectorAll('.cpp-colour-swatch.active')].find(swatch => swatch.dataset.productId === this.dataset.productId);
        this.showPrice(selected?.dataset.variantId || this.dataset.initialVariant);
      });
      window.addEventListener('luresiave:colourChanged', event => {
        if (String(event.detail.productId) !== this.dataset.productId) return;
        this.prices ||= JSON.parse(this.querySelector('[data-variant-prices]').textContent);
        this.showPrice(event.detail.variantId);
      }, { signal });
    }
    disconnectedCallback() { cancelAnimationFrame(this.frame); this.controller?.abort(); }
    showPrice(variantId) {
      if (!Object.hasOwn(this.prices, String(variantId))) return;
      this.querySelector('[data-current-price]').textContent = this.prices[variantId];
      this.dataset.currentVariant = variantId;
    }
  }
  if (!customElements.get('cpp-product-price')) customElements.define('cpp-product-price', CppProductPrice);
  class CppProductGallery extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initGallery());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.scrollFrame);
      clearTimeout(this.settleTimer);
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }
    initGallery() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.track = this.querySelector('.cpp-slider-wrapper');
      if (!this.track) return;
      this.slides = [...this.track.querySelectorAll('.cpp-slide')];
      this.thumbs = [...this.querySelectorAll('[data-gallery-slot]')];
      this.originals = this.slides.map(slide => {
        const img = slide.querySelector('img');
        return { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') || '', alt: img.alt };
      });
      this.index = 0;
      this.querySelector('.cpp-arrow-prev')?.addEventListener('click', () => this.go(this.index - 1), { signal });
      this.querySelector('.cpp-arrow-next')?.addEventListener('click', () => this.go(this.index + 1), { signal });
      this.thumbs.forEach(thumb => thumb.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.go(this.visibleSlides().findIndex(slide => slide.dataset.sliderSlot === thumb.dataset.gallerySlot));
      }, { signal }));
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => {
          // Keep a clicked destination selected while intermediate slides pass.
          if (this.targetIndex == null) this.syncPosition();
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => {
            this.targetIndex = null;
            this.syncPosition();
          }, 150);
        });
      }, { signal, passive: true });
      const interrupt = () => {
        if (this.targetIndex == null) return;
        this.targetIndex = null;
        clearTimeout(this.settleTimer);
        this.track.scrollTo({ left: this.track.scrollLeft, behavior: 'instant' });
        this.syncPosition();
      };
      this.track.addEventListener('pointerdown', interrupt, { signal, passive: true });
      this.track.addEventListener('wheel', interrupt, { signal, passive: true });
      this.track.addEventListener('keydown', event => {
        const index = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.visibleSlides().length - 1 }[event.key];
        if (index === undefined) return;
        event.preventDefault(); this.go(index);
      }, { signal });
      window.addEventListener('luresiave:colourChanged', event => this.changeColour(event.detail), { signal });
      this.resizeObserver?.disconnect();
      this.resizeObserver = new ResizeObserver(() => this.go(this.index, false));
      this.resizeObserver.observe(this.track);
      this.updateControls();
      // Handle a saved selection that ran before this custom element upgraded.
      const active = this.closest('.custom-product-page')?.querySelector('.cpp-colour-swatch.active');
      if (active && active.dataset.colourIndex !== '1') {
        this.changeColour({ productId: active.dataset.productId, images: [1, 2].map(i => ({ src: active.getAttribute('data-img-' + i), srcset: active.getAttribute('data-img-' + i + '-srcset') })).filter(image => image.src && image.src.length > 5) });
      }
    }
    visibleSlides() { return this.slides.filter(slide => !slide.hidden); }
    syncPosition() {
      const slides = this.visibleSlides();
      if (!slides.length) return;
      const index = slides.reduce((best, slide, index) => Math.abs(slide.offsetLeft - this.track.scrollLeft) < Math.abs(slides[best].offsetLeft - this.track.scrollLeft) ? index : best, 0);
      if (index === this.index) return;
      this.index = index;
      this.updateControls();
    }
    go(index, animate = true) {
      const slides = this.visibleSlides();
      this.index = Math.max(0, Math.min(index, slides.length - 1));
      const slide = slides[this.index];
      if (!slide) return;
      const smooth = animate && !matchMedia('(prefers-reduced-motion: reduce)').matches;
      clearTimeout(this.settleTimer);
      this.targetIndex = smooth ? this.index : null;
      // Request the selected image now, including when it is far outside the viewport.
      slide.querySelector('img').loading = 'eager';
      this.track.scrollTo({ left: slide.offsetLeft, behavior: smooth ? 'smooth' : 'instant' });
      this.updateControls(smooth);
      if (smooth) this.settleTimer = setTimeout(() => {
        this.targetIndex = null;
        this.syncPosition();
      }, 150);
    }
    updateControls(smooth = false) {
      const slides = this.visibleSlides();
      const active = slides[this.index];
      const previous = this.querySelector('.cpp-arrow-prev'), next = this.querySelector('.cpp-arrow-next');
      if (previous) { previous.disabled = this.index <= 0; previous.hidden = slides.length < 2; }
      if (next) { next.disabled = this.index >= slides.length - 1; next.hidden = slides.length < 2; }
      const current = this.querySelector('[data-gallery-current]'), total = this.querySelector('[data-gallery-total]');
      if (current) current.textContent = String(this.index + 1);
      if (total) total.textContent = String(slides.length);
      this.thumbs.forEach(thumb => {
        const slide = this.slides.find(item => item.dataset.sliderSlot === thumb.dataset.gallerySlot);
        thumb.hidden = !!slide?.hidden;
        if (slide === active) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      this.slides.forEach(slide => { const link = slide.querySelector('a'); if (link) link.tabIndex = slide === active ? 0 : -1; });
      const thumb = this.thumbs.find(item => item.hasAttribute('aria-current'));
      const strip = this.querySelector('.cpp-gallery-thumbnails');
      if (thumb && strip) {
        const delta = thumb.getBoundingClientRect().left - strip.getBoundingClientRect().left;
        if (delta < 0 || delta + thumb.offsetWidth > strip.clientWidth) strip.scrollTo({ left: strip.scrollLeft + delta - (strip.clientWidth - thumb.offsetWidth) / 2, behavior: smooth ? 'smooth' : 'instant' });
      }
    }
    changeColour(detail) {
      if (detail.productId && this.dataset.productId && String(detail.productId) !== this.dataset.productId) return;
      const images = detail.images || [];
      this.slides.forEach((slide, index) => {
        const slot = Number(slide.dataset.sliderSlot);
        if (slot > 2) return; // Keep existing shared editorial images in slots 3–6.
        const source = images.length ? images[slot - 1] : this.originals[index];
        slide.hidden = !source;
        if (!source) return;
        const img = slide.querySelector('img');
        img.src = source.src;
        img.srcset = source.srcset || '';
        const thumbnail = this.thumbs.find(item => Number(item.dataset.gallerySlot) === slot)?.querySelector('img');
        if (thumbnail) {
          const url = new URL(source.src, location.href);
          url.searchParams.set('width', '160');
          thumbnail.removeAttribute('srcset'); thumbnail.src = url.href;
        }
      });
      this.go(0, false);
    }
  }
  if (!customElements.get('cpp-product-gallery')) customElements.define('cpp-product-gallery', CppProductGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-we-help"] && !Shopify.designMode) return;
  try {
    
  class HowWeHelpSection {
    constructor(sectionId) {
      this.sectionId = sectionId;
      this.section = document.querySelector(`[data-section-id="${sectionId}"]`);
      if (!this.section) return;

      this.tabs = this.section.querySelectorAll('.how-we-help-section__tab');
      this.tabContents = this.section.querySelectorAll('.how-we-help-section__tab-content');
      this.videoButtons = this.section.querySelectorAll('.how-we-help-section__video-poster-button');

      this.init();
      this.ensureOrder();
    }

    init() {
      // Tab switching
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          const tabIndex = parseInt(tab.dataset.tabIndex, 10);
          this.switchTab(tabIndex);
        });
      });

      // Video play buttons
      this.videoButtons.forEach((button) => {
        const deferredMedia = button.closest('deferred-media');
        if (deferredMedia) {
          button.addEventListener('click', () => {
            this.playVideo(deferredMedia);
          });
        }
      });
    }

    // Zorgt dat de sectie DOM-technisch onder de slideshow komt te staan
    ensureOrder() {
      const slideshow = document.querySelector('.custom-slideshow-section');
      if (!slideshow || !this.section || !this.section.parentNode) return;

      // Als onze sectie vóór de slideshow staat in de DOM → verplaats 'm erna
      const relation = this.section.compareDocumentPosition(slideshow);
      const SECTION_BEFORE_SLIDESHOW = Node.DOCUMENT_POSITION_FOLLOWING;

      if (relation & SECTION_BEFORE_SLIDESHOW) {
        slideshow.insertAdjacentElement('afterend', this.section);
      }
    }

    switchTab(tabIndex) {
      const activeTabBg = this.section.dataset.activeTabBg || '';
      const activeTabColor = this.section.dataset.activeTabColor || '';
      const inactiveTabColor = this.section.dataset.inactiveTabColor || '';
      const inactiveTabBorder = this.section.dataset.inactiveTabBorder || '';

      // Update tabs
      this.tabs.forEach((tab, index) => {
        const isActive = index === tabIndex;
        tab.classList.toggle('how-we-help-section__tab--active', isActive);
        tab.setAttribute('aria-selected', isActive);

        if (isActive) {
          tab.style.backgroundColor = activeTabBg;
          tab.style.color = activeTabColor;
          tab.style.borderColor = 'transparent';
        } else {
          tab.style.backgroundColor = 'transparent';
          tab.style.color = inactiveTabColor;
          tab.style.borderColor = inactiveTabBorder;
        }
      });

      // Update tab contents
      this.tabContents.forEach((content, index) => {
        const isActive = index === tabIndex;
        content.classList.toggle('how-we-help-section__tab-content--active', isActive);
        if (isActive) {
          content.removeAttribute('hidden');
        } else {
          content.setAttribute('hidden', '');
        }
      });
    }

    playVideo(deferredMedia) {
      const template = deferredMedia.querySelector('template');
      if (!template) return;

      const videoContent = template.content.cloneNode(true);
      const videoElement = videoContent.querySelector('iframe, video');

      if (videoElement) {
        const posterButton = deferredMedia.querySelector('.how-we-help-section__video-poster-button');
        if (posterButton) {
          posterButton.style.display = 'none';
        }
        deferredMedia.appendChild(videoElement);
      }
    }
  }

  // Initialize sections
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.how-we-help-section[data-section-id]');
    sections.forEach((section) => {
      const sectionId = section.dataset.sectionId;
      new HowWeHelpSection(sectionId);
    });
  });

  // Re-initialize when theme editor updates
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail.sectionId) {
        const section = document.querySelector(`[data-section-id="${event.detail.sectionId}"]`);
        if (section && section.classList.contains('how-we-help-section')) {
          new HowWeHelpSection(event.detail.sectionId);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats"] && !Shopify.designMode) return;
  try {
    
  class StatsCounter {
    constructor(element) {
      this.element = element;
      const targetValue = parseFloat(element.dataset.target) || 0;
      this.target = targetValue;
      this.isDecimal = targetValue % 1 !== 0;
      this.decimalPlaces = this.isDecimal ? (targetValue.toString().split('.')[1] || '').length : 0;
      this.duration = parseInt(element.dataset.duration) || 2000;
      this.startValue = 0;
      this.startTime = null;
      this.animated = false;
      this.observer = null;
      
      this.init();
    }

    init() {
      // Use Intersection Observer to trigger animation when element is visible
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && !this.animated) {
                this.animate();
                this.observer.unobserve(entry.target);
              }
            });
          },
          {
            threshold: 0.5,
            rootMargin: '0px'
          }
        );
        this.observer.observe(this.element);
      } else {
        // Fallback for browsers without IntersectionObserver
        this.animate();
      }
    }

    animate() {
      if (this.animated) return;
      this.animated = true;
      this.startTime = performance.now();
      this.update();
    }

    update() {
      const now = performance.now();
      const elapsed = now - this.startTime;
      const progress = Math.min(elapsed / this.duration, 1);

      // Easing function (ease-out)
      const easeOut = 1 - Math.pow(1 - progress, 3);
      let currentValue = this.startValue + (this.target - this.startValue) * easeOut;

      // Handle decimal numbers
      if (this.isDecimal) {
        currentValue = parseFloat(currentValue.toFixed(this.decimalPlaces));
      } else {
        currentValue = Math.floor(currentValue);
      }

      this.element.textContent = this.formatNumber(currentValue);

      if (progress < 1) {
        requestAnimationFrame(() => this.update());
      } else {
        this.element.textContent = this.formatNumber(this.target);
      }
    }

    formatNumber(num) {
      // Format number with proper decimal handling
      if (this.isDecimal) {
        return num.toFixed(this.decimalPlaces).replace('.', ',');
      } else {
        // Add thousand separators for whole numbers
        return num.toLocaleString('nl-NL');
      }
    }
  }

  // Initialize all counters when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    const counters = document.querySelectorAll('.stats-section__number[data-target]');
    counters.forEach((counter) => {
      new StatsCounter(counter);
    });
  });

  // Re-initialize when theme editor updates
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail.sectionId) {
        const section = document.querySelector(`[data-section-id="${event.detail.sectionId}"]`);
        if (section) {
          const counters = section.querySelectorAll('.stats-section__number[data-target]');
          counters.forEach((counter) => {
            new StatsCounter(counter);
          });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
